import { ComponentProps } from 'react';

export function LightningBolt({ className = 'w-auto h-4', ...props }: ComponentProps<'svg'>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none" className={className} {...props}>
			<path
				d="M6.3578 5.79306L3.46835 10.8784L3.89749 7.75983L3.97567 7.19167H3.40216H1.64511L4.54825 2.11663L4.11889 5.22463L4.04036 5.79306H4.61419H6.3578Z"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth="0.5"
			/>
		</svg>
	);
}
